import { render, staticRenderFns } from "./SupportTable.vue?vue&type=template&id=67087802&"
import script from "./SupportTable.vue?vue&type=script&lang=ts&"
export * from "./SupportTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports